"use client";

import Image from "next/image";
import Link from "next/link";
import { SectionLayout } from "@/components/layout/SectionLayout";
import { MyNauiLongArrowRight } from "@/assets/icons/mynaui-long-arrow-right";
import introHeadSpaImage from "@/assets/images/head-spa/intro-head-spa.jpg";

const PLANITY_URL = "https://www.planity.com/au-grey-des-couleurs-94800-villejuif";
const HEAD_SPA_ADDRESS = "1 Rue Eugène Varlin, 94800 Villejuif";

export const HeadSpaFeaturedServiceSection = () => {
  return (
    <SectionLayout id="featured-service">
      <div className="mx-auto grid w-full max-w-7xl grid-cols-1 items-start gap-12 md:grid-cols-[1.2fr_1fr] md:gap-16 lg:gap-20">
        {/* Image verticale - format portrait, plus large sur desktop */}
        <div className="relative aspect-[4/5] w-full overflow-hidden md:aspect-[5/6]">
          <Image
            src={introHeadSpaImage}
            alt="Soin Rituel d'été - Head Spa L'Instant Grey"
            fill
            sizes="(max-width: 768px) 100vw, 55vw"
            className="object-cover"
            priority
          />
          {/* Barre décorative gold */}
          <div className="absolute left-0 top-0 h-1 w-24 bg-gold" />
        </div>

        {/* Contenu */}
        <div className="flex flex-col gap-8">
          <div className="flex flex-col gap-4">
            <span className="text-sm uppercase tracking-[0.2em] text-gold">
              Soin signature
            </span>
            <h2 className="font-cormorant text-4xl font-light text-primary ph:text-5xl sm:text-6xl lg:text-7xl">
              Soin Rituel d&apos;été
            </h2>
            <div className="flex items-center gap-6 text-sm text-gray-600">
              <span>1h 15min - 99€ </span>

            </div>
            <p className="w-fit border-l-2 border-gold bg-gold/10 px-3 py-2 text-sm font-medium text-primary">
              Au salon : {HEAD_SPA_ADDRESS}
            </p>
          </div>

          <p className="max-w-xl text-lg leading-relaxed text-gray-700">
            Un rituel complet pour purifier le corps, stimuler le cuir chevelu et
            relancer les énergies.{" "}
            <span className="italic text-primary">
              Chaque geste, précis et fluide, offre une détente profonde et un
              véritable instant de bien-être.
            </span>
          </p>

          <div className="flex flex-col gap-3">
            <div className="h-px w-12 bg-gold" />
            <ul className="flex flex-col gap-2">
              {[
                "Un rituel complet pour purifier le corps, stimuler le cuir chevelu et relancer les énergies",
                "Chaque geste, précis et fluide, offre une détente profonde et un véritable instant de bien-être.",
                "Un soin express mais complet, pour accueillir l'été avec légèreté et sérénité.",
              ].map((benefit, idx) => (
                <li key={idx} className="flex items-start gap-3">
                  <svg
                    className="mt-1 h-4 w-4 shrink-0 text-gold"
                    fill="currentColor"
                    viewBox="0 0 20 20"
                  >
                    <path
                      fillRule="evenodd"
                      d="M10 18a8 8 0 100-16 8 8 0 000 16zm3.707-9.293a1 1 0 00-1.414-1.414L9 10.586 7.707 9.293a1 1 0 00-1.414 1.414l2 2a1 1 0 001.414 0l4-4z"
                      clipRule="evenodd"
                    />
                  </svg>
                  <span className="text-gray-700">{benefit}</span>
                </li>
              ))}
            </ul>
          </div>

          <div className="pt-4">
            <Link
              href={PLANITY_URL}
              target="_blank"
              rel="noopener noreferrer"
              className="group relative inline-flex w-fit items-center gap-2 overflow-hidden border border-primary bg-white px-8 py-3 text-base font-medium text-primary transition-colors ph:text-lg"
            >
              <span className="relative z-10 transition-colors group-hover:text-white">
                Réserver ce soin
              </span>
              <span className="relative z-10 transition-colors group-hover:text-white">
                <MyNauiLongArrowRight className="h-4 w-4 ph:h-5 ph:w-5" />
              </span>
              <div className="absolute bottom-0 left-0 h-full w-0 bg-primary transition-all duration-300 ease-out group-hover:w-full" />
            </Link>
          </div>
        </div>
      </div>
    </SectionLayout >
  );
};
